import React from 'react';
import { IHomePage } from './types';
import style from './style.module.scss';
import { ReportingDashboard } from '../Dashboard';

const NS = 'HomePage';

export default function HomePage({ handleSomeClick}: IHomePage) {

  return (
    <>
      <ReportingDashboard />
    </>
  )
}